"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const pageTypeMap: Record<string, string> = {
	"/news": "NEWS_PAGE",
	"/genres": "GENRES_PAGE",
	"/categories": "CATEGORIES_PAGE",
	"/": "HOME_PAGE",
};

export default function TrackPageVisit() {
	const pathname = usePathname();

	useEffect(() => {
		const matchedKey = Object.keys(pageTypeMap).find((key) =>
			pathname.includes(key),
		);

		if (matchedKey) {
			const pageType = pageTypeMap[matchedKey];

			fetch(`${process.env.NEXT_PUBLIC_API_URL}/public/track/visit`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ pageType }),
				keepalive: true, // ← Super important for reliability
			}).catch(() => {
				// silently ignore — never break UX
			});
		}
	}, [pathname]);

	return null;
}
